import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useCommunicationService } from 'app/services/communication';
import { MessageType } from 'app/utils/in-app-comunication/types';
import useServices from 'app/services';
import useConfig from 'app/config';
import { useDispatch, useAppState } from 'state';
import { signin } from 'actions/auth';
import { useCookieConsent } from 'app/hooks/use-cookie-consent';
import HyroxLogo from 'src/app/ui/components/atoms/icons/hyrox-logo';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.black};
`;

const LogoContainer = styled.div`
  width: 50%;
`;

const AuthListener = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const comms = useCommunicationService();
  const services = useServices();
  const { config } = useConfig();
  const signedIn = useAppState(({ auth }) => auth.signedIn);
  const { hasConsentBeenSet, acceptAll } = useCookieConsent();

  const exchangeAuthCodeForToken = async (code: string) => {
    if (signedIn) {
      navigate('/');
    }
    try {
      console.log('Exchanging auth code for token...');
      const tokenResponse = await services.auth.exchangeCodeForToken({
        code,
        redirectUri: config.REACT_APP_AUTH_CALLBACK_REDIRECT_URL,
      });

      console.log('Token exchange successful:', tokenResponse);

      // Dispatch signin action to update auth state
      dispatch(
        signin({
          accessToken: tokenResponse.accessToken,
          accessTokenExpiresAt: tokenResponse.accessTokenExpiresAt,
          refreshToken: tokenResponse.refreshToken,
          refreshTokenExpiresAt: tokenResponse.refreshTokenExpiresAt,
        }),
      );
    } catch (error) {
      console.error('Token exchange failed:', error);
    }
  };

  // Auto-accept cookies on auth-listener page
  useEffect(() => {
    if (!hasConsentBeenSet) {
      acceptAll();
    }
  }, [hasConsentBeenSet, acceptAll]);

  useEffect(() => {
    if (signedIn) {
      navigate('/');
    }
  }, [signedIn]);

  useEffect(() => {
    const unsubscribe = comms.onMessage((message) => {
      console.log('Message received:', message);
      if (message.type === MessageType.AUTH_CODE_RECEIVED && message.authCode) {
        console.log('Auth code received:', message.authCode);

        // Automatically exchange the auth code for a token
        exchangeAuthCodeForToken(atob(message.authCode));
      }
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [comms]);

  return (
    <Container>
      <LogoContainer>
        <HyroxLogo />
      </LogoContainer>
    </Container>
  );
};

export default AuthListener;
